import { render, staticRenderFns } from "./TopBar.vue?vue&type=template&id=709622b3&"
import script from "./TopBar.js?vue&type=script&lang=js&"
export * from "./TopBar.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/mijnmooiestraat.vlaanderen/staging.mijnmooiestraat.vlaanderen/pro-staging.mijnmooiestraat.vlaanderen/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('709622b3')) {
      api.createRecord('709622b3', component.options)
    } else {
      api.reload('709622b3', component.options)
    }
    module.hot.accept("./TopBar.vue?vue&type=template&id=709622b3&", function () {
      api.rerender('709622b3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/TopBar/TopBar.vue"
export default component.exports